import { render, staticRenderFns } from "./OGenerate.vue?vue&type=template&id=35e2fc17&scoped=true"
import script from "./OGenerate.vue?vue&type=script&lang=js"
export * from "./OGenerate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e2fc17",
  null
  
)

export default component.exports